export default __webpack_public_path__ + "graphics/stockings--blurred.a9f35476.jpg";